import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { isOptionSelected } from '../helpers'
import { OptionLink } from '../styles'
import * as Styles from './styles'

const OptionWithChildren = ({ option, isParentSelected, currentPath }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const isSelected = link => isOptionSelected(currentPath, link)

  return (
    <Styles.Container>
      <Styles.HeaderList isParentSelected={isParentSelected}>
        {option?.Icon && (
          <option.Icon
            size="24"
            color={isParentSelected ? theme.colors.text.inverse : theme.colors.text.default}
            weight={isParentSelected ? option?.iconWeights.selected : option.iconWeights.default}
          />
        )}
        <Text
          tag="p"
          type={isParentSelected ? 'bodyMBold' : 'bodyMRegular'}
          color={isParentSelected ? theme.colors.text.inverse : theme.colors.text.default}
        >
          {t(option?.label)}
        </Text>
      </Styles.HeaderList>
      <Styles.ChildrenList isParentSelected={isParentSelected}>
        {option?.children
          ?.filter(child => child.visible)
          .map((child, index) => (
            <Styles.ChildItem key={index} isSelected={isSelected(child.link)} isParentSelected={isParentSelected}>
              <child.Icon
                weight={isSelected(child.link) ? child?.iconWeights.selected : child.iconWeights.default}
                color={isSelected(child.link) ? theme.colors.outline.default : theme.colors.text.default}
                size="24"
              />
              <OptionLink to={child?.link}>
                <Text
                  tag="p"
                  type={isSelected(child.link) ? 'bodyMBold' : 'bodyMRegular'}
                  color={isSelected(child.link) ? theme.colors.outline.default : theme.colors.text.default}
                >
                  {t(child?.label)}
                </Text>
              </OptionLink>
            </Styles.ChildItem>
          ))}
      </Styles.ChildrenList>
    </Styles.Container>
  )
}

export default OptionWithChildren
